import React from 'react';
import { MAP_CONSTANTS } from '../constants';
import ration from '../static/ration.png';
import hunger from '../static/hunger.png';
import shelter from '../static/shelter.png';
import epass from '../static/epass.png';
import migrant from '../static/migrant.png';
import senior from '../static/senior.png';
import transport from '../static/transport.png';
import adobe from '../static/adobe.svg';
import shramik_train from '../static/Migrant_Labour.png'
import delhigovt from '../static/delhigovt.svg';
import OtherLinks from './OtherLinks';
import Footer from './Footer';
import stranded_abroad from '../static/transport_abroad.png';
import travel_from_del from '../static/trains_to_other.png';
import openInNewTab from '../utils/openInNewTab';

const initialState = {
  showModal: false,
  selectedMapURL: '',
};

class LockdownServices extends React.Component {
  state = initialState;

  // TODO: REPITITIVE FUNCTION MOVE TO A REDUCER IN STATE - Aman
  handleModalOpen = (selectedMapURL) => {
    openInNewTab(selectedMapURL);
    // this.setState({ selectedMapURL, showModal: true });
  }

  /*  handleModalClose = () => {
      this.setState({ selectedMapURL: '', showModal: false });
    } */

  render() {
    return (
      <div>
        <main>
          <div className="maintitlebar">
            <h1>Delhi Government<br />Lockdown Services</h1>
            <img alt="Delhi Govt Logo" className="delhi-govt-logo" src={delhigovt} style={{ height: '70px' }} />
          </div>
          <div id="main--sections">
            <div id="services">
              <div className="services--item" style={{ backgroundImage: `url(${ration})` }}>
              <a target="_blank"  rel="noopener noreferrer" href="https://ration.jantasamvad.org/ration/">
                <div id="services-one"  >
                  Apply for Ration
                </div>
              </a>
              </div>
              <div className="services--item" style={{ backgroundImage: `url(${hunger})` }}>
              <a   onClick={() => this.handleModalOpen(MAP_CONSTANTS.hungerReliefCenter)}>
                <div id="services-two"  >
                  Find a Hunger Relief Center
                </div>
              </a>
              </div>
              <div className="services--item" style={{ backgroundImage: `url(${shelter})` }}>
              <a  onClick={() => this.handleModalOpen(MAP_CONSTANTS.tempStayShelters)}>
                <div id="services-three"  >
                  Find a Shelter
                </div>
              </a>
              </div>
              <div className="services--item" style={{ backgroundImage: `url(${epass})` }}>
              <a   target="_blank" rel="noopener noreferrer" href="https://epass.jantasamvad.org/epass/init/">
                <div id="services-four" >
                  Get a Curfew e-Pass for mobility
                </div>
              </a>
              </div>
              <div  className="services--item" style={{ backgroundImage: `url(${shramik_train})` }}>
              <a target="_blank" rel="noopener noreferrer" href="https://epass.jantasamvad.org/train/passenger/">
                <div id="services-five" >
                  Shramik Vikas Train (For Delhi Migrant Labour)
                </div>
              </a>
              </div>
              <div className="services--item" style={{ backgroundImage: `url(${travel_from_del})` }}>
              <a 
                target="_blank"
                rel="noopener noreferrer"
                href="https://epassdocs.epass.jantasamvad.org/epass/stranded-travel/english/"
              >
                <div id="services-six"  >
                  Travel From Delhi To Other States
                </div>
              </a>
              </div>
              <div className="services--item" style={{ backgroundImage: `url(${stranded_abroad})` }}>
              <a 
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.delhishelterboard.in/covid19/registration-2.php"
              >
                <div id="services-seven"  >
                 Relief For Indians Stranded Abroad
                </div>
              </a>
              </div>
              <div className="services--item" style={{ backgroundImage: `url(${migrant})` }}>
              <a 
                target="_blank"
                rel="noopener noreferrer"
                href="http://tte.delhigovt.nic.in/wps/wcm/connect/doit_dbcwwb/DBCWWB/home/"
              >
                <div id="services-eight"  >
                  Compensation for Migrant Labour
                </div>
              </a>
              </div>
              <div className="services--item" style={{ backgroundImage: `url(${senior})` }}>
              <a 
                target="_blank"
                rel="noopener noreferrer"
                href="http://www.socialwelfare.delhigovt.nic.in/home/social-welfare-department"
              >
                <div id="services-nine"  >
                  Pension for Senior Citizens, Disabled &amp; Widows
                </div>
              </a>
              </div>
              <div  className="services--item" style={{ backgroundImage: `url(${transport})` }}>
              <a  target="_blank" rel="noopener noreferrer" href="http://pucc.delhi.gov.in/cvfa/">
                <div id="services-ten"  >
                  Compensation for Transport Providers
                </div>
              </a>
              </div>
            </div>
            <div>
              <div className="asideComponent">
                <h6>Downloads</h6>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://nctdelhi.blob.core.windows.net/nctdelhi/DelhiCovidShelter.pdf"
                >
                  <div className="asideComponentItem"><img src={adobe} style={{ marginRight: '8px' }} />List of shelters
                  </div>
                </a>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://nctdelhi.blob.core.windows.net/nctdelhi/DelhiContainmentZones.pdf"
                >
                  <div className="asideComponentItem"><img src={adobe} style={{ marginRight: '8px' }} />List of hunger
                    relief centers &amp; ration centers
                  </div>
                </a>
              </div>
              <OtherLinks />
            </div>
          </div>
        </main>
        <Footer />
      </div>
    );
  }
}

export default LockdownServices;
